export default "__VITE_ASSET__72Xu4CHL__"